module.exports = __webpack_public_path__ + "static/media/S4N9-3.05472002.svg";